module.exports = __webpack_public_path__ + "img/b3.c7164c83.png";